import * as React from 'react'
import { RecommendedArticleComponentProps } from '../types'
import { RecommendedArticleItemCategory, RecommendedArticleItemTitle } from '../styled'
import {
  CustomerStoriesComponentWrapper,
  CustomerStoriesContentWrapper,
  CustomerStoriesMedia,
  CustomerStoriesMediaWrapper,
  StyledArticleContentSeparator,
} from './styled'

export const CustomerStoriesItem = ({
  isSmall,
  isYoutube,
  src,
  alt,
  category,
  to,
  title,
  component,
}: RecommendedArticleComponentProps) => {
  return (
    <CustomerStoriesComponentWrapper $isSmall={isSmall} to={to}>
      {src && (
        <CustomerStoriesMediaWrapper $isSmall={isSmall}>
          <CustomerStoriesMedia $isSmall={isSmall} $isYoutube={isYoutube} src={src} alt={alt} />
        </CustomerStoriesMediaWrapper>
      )}
      {!isSmall && <StyledArticleContentSeparator />}
      <CustomerStoriesContentWrapper $isSmall={isSmall}>
        <RecommendedArticleItemCategory component={component}>{category}</RecommendedArticleItemCategory>
        <RecommendedArticleItemTitle $isSmall={isSmall}>{title}</RecommendedArticleItemTitle>
      </CustomerStoriesContentWrapper>
    </CustomerStoriesComponentWrapper>
  )
}
